import { AnyAction } from 'redux'
import { GET_BOOTSTRAP_DATA, GET_COUNTRIES, GET_TOKEN } from '../actions/types'

export const token = (state = '', action: AnyAction) => {
  switch (action.type) {
    case GET_TOKEN:
      return action.key || ''

    default:
      return state
  }
}

// country codes :
export interface countriesItemsProps {
  name: string
  dial_code: string
  code: string
  flag: string
  persian_name: string
}

export interface countriesStateProps {
  data: countriesItemsProps[]
  loading: boolean
}

interface countriesActionProps extends countriesStateProps {
  type: string
}

export const countries = (
  state: countriesStateProps = { data: [], loading: false },
  { type, data, loading }: countriesActionProps,
): countriesStateProps => {
  switch (type) {
    case GET_COUNTRIES:
      return { data, loading }

    default:
      return state
  }
}

export interface BootstrapDataState {
  data: {
    bookmark_ids: number[]
    notices: any[]
    socket_driver: any
    wallet_recharge_gateway_id: number | null
    user_info: {
      atu: string | null
      uid: string
      name: string
      family: string
      mobile: string
      picture: string | null
      is_host: boolean
      has_active_company: boolean
      incomplete_house?: boolean
      credit: {
        amount: number
        currencyName: string
        currencyShortForm: string
      }
      gift_credit: {
        amount: number
        currencyName: string
        currencyShortForm: string
      }
    }
  }
  loading: boolean
}

export const initialBootstrapData: BootstrapDataState = {
  data: {
    bookmark_ids: [],
    notices: [],
    socket_driver: '',
    wallet_recharge_gateway_id: null,
    user_info: {
      atu: null,
      uid: '',
      name: '',
      family: '',
      mobile: '',
      picture: null,
      is_host: false,
      incomplete_house: false,
      has_active_company: false,
      credit: {
        amount: 0,
        currencyName: 'تومان',
        currencyShortForm: 'ت',
      },
      gift_credit: {
        amount: 0,
        currencyName: 'تومان',
        currencyShortForm: 'ت',
      },
    },
  },
  loading: false,
}

interface BootstrapActionProps extends BootstrapDataState {
  type: string
}

export const bootstrapData = (
  state: BootstrapDataState = initialBootstrapData,
  action: BootstrapActionProps,
) => {
  switch (action.type) {
    case GET_BOOTSTRAP_DATA:
      return { ...state, data: action.data, loading: action.loading }

    default:
      return state
  }
}
